import Vue from 'vue'
import Router from 'vue-router'
import GeoStatusKeyInput from './views/GeoStatusKeyInput.vue'
import GeoStatusMap from './views/GeoStatusMap.vue'
import GeoStatusPresentMap from './views/GeoStatusPresentMap.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: "home",
            component: GeoStatusKeyInput
        },
        {
            path: '/map',
            name: "map",
            component: GeoStatusMap
        },
        {
            path: '/pres',
            name: "pres",
            component: GeoStatusPresentMap
        }
    ],
    linkActiveClass: 'active'
})
